/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import Title from "../components/UI/Title";
import { URL_API } from "../config/default";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AlojamientoPlaceholder from "../components/UI/Spinner/AlojamientoPlaceholder";
import { myHeaders } from "../config/axios";
import { CustomToast } from "../utils/custom-toast";
import Error from "./Error/Index";
import AccommodationCard from "../components/UI/Accommodation-card";
import { useAppContext } from "../contexts/AppProvider";
import ExcursionCard from "../components/UI/excursion-card";

const Favoritos = () => {
  const { me }: any = useAppContext();

  const setFavorito = (property: any) => {
    const requestOptions = {
      method: "DELETE",
      headers: {
        Authorization: myHeaders,
      },
    };

    return fetch(`${URL_API}/favorites/${property.id}`, requestOptions)
      .then(async (response) => {
        await response.json();
        return CustomToast({
          status: 200,
          msg: "",
          title: "Alojamiento eliminado de favoritos",
        });
      })
      .catch((error) => console.error(error));
  };

  const { isPending, error, data } = useQuery({
    queryKey: ["favoritos"],
    queryFn: () => {
      const requestOptions = {
        headers: {
          Authorization: myHeaders,
        },
      };
      return fetch(`${URL_API}/favorites`, requestOptions).then((res) =>
        res.json()
      );
    },
  });

  if (isPending)
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1">
        {[1, 2, 3, 4].map((index) => {
          return <AlojamientoPlaceholder key={index} />;
        })}
      </div>
    );

  if (error) return <Error />;


  return (
    <div className="mx-auto border-0 w-[100%] md:w-[80%] min-h-screen">
      <Title text="Favoritos" link="#" />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {data?.data?.map((fav: any, index: any) => {
          const alojamiento = fav.property;
          const excursion = fav.excursion;
          if (alojamiento) {
            return <AccommodationCard
              key={index}
              destination={alojamiento}
              setFavorito={setFavorito}
              favoritos={{data: []}}
              user={me ?? null}
            />;
          }

          if (excursion) {
            return <ExcursionCard
              key={index}
              destination={excursion}
              setFavorito={setFavorito}
              favoritos={{data: []}}
              user={me ?? null}
            />;
          }
        })}
      </div>
    </div>
  );
};

export default Favoritos;
